import Vue from 'vue';
export { createNamespace, createBrandName } from './create';
export { value2DomUnit, value2Number } from './dom/unit';
export var isServer = Vue.prototype.$isServer;
export function isObj(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}
export function isNumber(value) {
  return /^\d+(\.\d+)?$/.test(value);
}
export function isDef(value) {
  return value !== undefined && value !== null;
}
export function get(object, path) {
  var keys = path.split('.');
  var result = object;
  keys.forEach(function (key) {
    result = isDef(result[key]) ? result[key] : '';
  });
  return result;
}